import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IActionMethodModel, IFeedbackModel } from 'src/app/share/entities/data-model';
import { IActionModel } from 'src/app/share/entities/data-view';
import { IDataPanelViewModel, IStatViewModel, IViewData } from 'src/app/share/entities/view-model';
import { IPageDataViewModel } from 'src/app/share/pages/pages';
import { AuthService } from 'src/app/share/services/auth.service';
import { CommonService } from 'src/app/share/services/common.service';

@Component({
  selector: 'app-aff-port-exception',
  templateUrl: './aff-port-exception.component.html',
  styleUrls: ['./aff-port-exception.component.scss']
})
export class AffPortExceptionComponent implements OnInit {

  constructor(private commonService: CommonService, private authService: AuthService, private http: HttpClient) { }

  vm$: Observable<any>
  fb: IFeedbackModel = {

  };

  private affPortExcExecute$(): Observable<IPageDataViewModel> {
    return this.commonService.getData('PageCommand', 'affport.exceptions', 'page-load').pipe(
      map((v: IViewModelAffPortExc) => {
        if (v.workingText)
          return { ...v };

        const ret = { ...v, actionsAllowed: true };
        //console.log(ret.data);
        if (ret.data) {
          // stat panel 
          ret.statPanelVm = ret.data.statPanel ? {
            data: ret.data.statPanel
          } : null;

          ret.affiliatePortalExceptionsPanelVm = ret.data.affiliatePortalExceptionsPanel && !ret.data.affiliatePortalExceptionsPanel.unauthorized ? {
            data: ret.data.affiliatePortalExceptionsPanel,
            rows: ret.data.affiliatePortalExceptionsPanel.rows.map(r => ({ code: r[0], actionTitle: "Ticket", fields: r })),
            rowsFiltered: ret.data.affiliatePortalExceptionsPanel.rows.map(r => ({ code: r[0], actionTitle: "Ticket", fields: r })),
            styleTypes: ret.data.affiliatePortalExceptionsPanel.styleTypes,
            styleTypesFiltered: ret.data.affiliatePortalExceptionsPanel.styleTypes,
            actions: []
          } : null;
        }
        return ret;
      })
    );
  }

  ngOnInit() {
    this.vm$ = this.affPortExcExecute$();
  }

  /**
   * 
   */
   refreshPage() {
    this.vm$ = this.affPortExcExecute$();
    this.authService.userInRole;
  }

  /**
   * 
   */
   putTicket(am: IActionModel) {

   }

   /**
   * 
   */
    doAction(action: IActionMethodModel) {
      //console.log('parent action: ', action.name)
   }
}

/**
 * 
 */
 interface IViewModelAffPortExc extends IPageDataViewModel {
  data?: { statPanel: any, affiliatePortalExceptionsPanel: IViewData }

  statPanelVm: IStatViewModel;
  affiliatePortalExceptionsPanelVm: IDataPanelViewModel;

  actionsAllowed?: boolean;
}

